#import "../fragments/search-result-contact-fragment.graphql"
#import "../fragments/search-result-account-fragment.graphql"
#import "../fragments/search-result-lead-fragment.graphql"

query GetSearchResults($query: String!, $type: EntityType) {
    search(query: $query, type: $type) {
        quickResults {
            topResults {
                ... on Lead {
                    ...LeadSearchResult
                }
                ... on Account {
                    ...AccountSearchResult
                }
                ... on Contact {
                    ...ContactSearchResult
                }
            }
            recentResults {
                ... on Lead {
                    ...LeadSearchResult
                }
                ... on Account {
                    ...AccountSearchResult
                }
                ... on Contact {
                    ...ContactSearchResult
                }
            }
            leadResults {
                ...LeadSearchResult
            }
            accountResults {
                ...AccountSearchResult
            }
            contactResults {
                ...ContactSearchResult
            }
        }
    }
}
